import { render, staticRenderFns } from "./DataComponent.vue?vue&type=template&id=8bc5208e&scoped=true"
import script from "./DataComponent.vue?vue&type=script&lang=js"
export * from "./DataComponent.vue?vue&type=script&lang=js"
import style0 from "./DataComponent.vue?vue&type=style&index=0&id=8bc5208e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc5208e",
  null
  
)

export default component.exports